
















import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class Thumb extends Vue {
    // Prop => Datas envoyée depuis le composent parent à l'enfant (ici)
    @Prop() private thumb1!: string
    @Prop() private thumb2!: string
    // Data => (vide pour le moment car elle sera nourrie avec les props)
    private Thumbs: Array < unknown > = []

    private addPropInArray (): void {
      if (this.Thumbs.length > 0) {
        // On reset la liste des thumbs a chaque changement de vue
        this.Thumbs.length = 0
      } else {
        this.Thumbs.push(this.thumb1 as unknown, this.thumb2 as unknown)
      }
    }

    // Ajoute un evenement "OnClick" sur les thumbs pour lancer la sauvegarde
    private addEventInThumb () : void {
      const body = document.querySelector('.thumb-container-mini')
      if (body) {
        const thumbs = document.querySelectorAll('.min-thumb')
        if (thumbs) {
          thumbs.forEach((thumb) => {
            thumb.addEventListener('click', (event) => {
              if (event) {
                const thumbCast = thumb as HTMLElement
                const thumbName = thumbCast.dataset.name
                if (thumbName) {
                  this.sendChoise(thumbName)
                }
              }
            }, false)
          })
        }
      }
    }

    // Envoie la donnée à la méthode vuex correspondante à l'étape courante
    private sendChoise (name: string): void {
      if (name) {
        this.$store.dispatch('saveStep3Options', name)
        this.updateStyleThumb(name)
      }
    }

    private updateStyleThumb (thumbsaved: string): void {
      if (thumbsaved) {
        const body = document.querySelector('.thumb-container-mini')
        if (body) {
          const thumbs = document.querySelectorAll('.min-thumb')
          thumbs.forEach((thumb) => {
            const thumbCast = thumb as HTMLElement
            const thumbName = thumbCast.dataset.name as string
            if (thumbsaved.localeCompare(thumbName)) {
              if (thumb.classList.contains('selected')) {
                thumb.classList.remove('selected')
              }
              thumb.classList.add('not-selected')
            } else {
              thumb.classList.add('selected')
              if (thumb.classList.contains('not-selected')) {
                thumb.classList.remove('not-selected')
              }
            }
          })
        }
      }
    }

    private updateThumb (): void {
      const thumbsaved = this.$store.getters.getValueForStep3Options
      return thumbsaved
    }

    created (): void {
      this.addPropInArray()
    }

    mounted (): void {
      this.addEventInThumb()
      this.updateThumb()
    }
}
